module.exports = __webpack_public_path__ + "img/zu3.411895db.png";